module.exports = __webpack_public_path__ + "fonts/VanillaExtractRegular.f417d21d.ttf";